import React, {Component} from "react";
import {Col, Row} from 'antd';
import PropTypes from "prop-types";

/**
 * 导航栏目详情
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {form, initViewFormData} = this.props;
        return (
            <div>
                <Row style={{marginBottom: '10px', fontSize: '16px'}}><b>自助报到信息</b></Row>
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>环节名称：</b>{initViewFormData.HJMC}</Col>
                    <Col span={12} style={{textAlign: 'left'}}><b>环节代码：</b>{initViewFormData.HJDM}</Col>
                </Row>
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>环节类型：</b>{initViewFormData.HJLXMC}</Col>
                    <Col span={12} style={{textAlign: 'left'}}><b>关联环节：</b>{initViewFormData.GLHJMC}</Col>
                </Row>
                
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>开始时间：</b>{initViewFormData.KSSJ}</Col>
                    <Col span={12} style={{textAlign: 'left'}}><b>排序号：</b>{initViewFormData.PXH}</Col>
                </Row>
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>结束时间：</b>{initViewFormData.JSSJ}</Col>
                    <Col span={12} style={{textAlign: 'left'}}><b>状态：</b>{initViewFormData.ZT}</Col>
                </Row>   
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>PC端办理提示：</b>{<div dangerouslySetInnerHTML={{__html: initViewFormData.PCBLTS}}/>}</Col>
                    <Col span={12} style={{textAlign: 'left'}}><b>移动端办理提示：</b>{<div dangerouslySetInnerHTML={{__html: initViewFormData.YDBLTS}}/>}</Col>
                </Row>            
            </div>
        )
    }
}

ViewForm.propTypes = {
    initViewFormData: PropTypes.object
};

export default ViewForm;


// WEBPACK FOOTER //
// ./components/fwwgl/zzbd/ViewForm.js